export default function Hero() {
  return (
    <section id="hero" className="hero">
      <h1 font-size="3rem">Find Your Perfect Vehicle With Confidence.</h1>
      <p>
        We help South Africans find quality vehicles with confidence and peace
        of mind.
        <br />
        From sourcing to finance — we take care of the entire journey.
      </p>
      <div
        style={{
          marginTop: "60px",
          display: "flex",
          flexWrap: "wrap",

          justifyContent: "center",
          gap: "10px",
        }}
      ></div>
    </section>
  );
}
